class AdSelectorDelegate {

    constructor($scope, $el, $uibModal, $timeout, $rootScope) {

        this.$scope = $scope;
        this.$el = $el;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.visible = false;

        this.copyLayerProps = {
            name: true,
            src: true,
            contentType: true,
            contentLength: true,
            width: true,
            height: true,
            encodings: true
        };

        this.handles = [
            { selector: ".selector-handle.drag-n", axis: "y" },
            { selector: ".selector-handle.drag-ne", axis: undefined },
            { selector: ".selector-handle.drag-e", axis: "x" },
            { selector: ".selector-handle.drag-se", axis: undefined },
            { selector: ".selector-handle.drag-s", axis: "y" },
            { selector: ".selector-handle.drag-sw", axis: undefined },
            { selector: ".selector-handle.drag-w", axis: "x" },
            { selector: ".selector-handle.drag-nw", axis: undefined }
        ];

        this.handlers = {
            "n": this.handleN,
            "ne": this.handleNE,
            "e": this.handleE,
            "se": this.handleSE,
            "s": this.handleS,
            "sw": this.handleSW,
            "w": this.handleW,
            "nw": this.handleNW
        };

        $rootScope.$on('updateSelectorDims', (ev, data) => {
            this.selectItem(data);
        });

    }

    handleDrop(asset) {
        if(this.$scope.selectedEntity.contentType === "x-reflow/layer") {
            this.$scope.adunit.assets[asset._id] = asset;
            let layerAsset = this.$scope.adunit.assets[this.$scope.selectedEntity.assetId];
            if("function" === typeof DROP_HANDLERS[layerAsset.contentType]) {                
                DROP_HANDLERS[layerAsset.contentType](this.$scope.selectedEntity, asset);
            }
            else {
                this.$scope.selectedEntity.assetId = asset._id;
            }
            this.$rootScope.$broadcast("render");
        }
    }

    selectBuilder() {
        if(!!this.$scope.selectedEntity) {
            this.$scope.selectedEntity.selected = false;
        }
        this.$el.css('display', 'none');
    }
    
    selectCanvas(ev, args) {
        this.selectItem(args);
    }
    
    selectLayer(ev, args) {
        this.selectItem(args);
    }
    
    selectItem(entity) {

        if(!entity) {
            return;
        }

        let type = entity.contentType.split("/")[1];
        this.$scope.entityAsset = null;
        this.$scope.selectedEntity = null;
        this.$el.css("display", "none");
        this.visible = false;

        // need to wait a bit to make sure that the element is created and all
        this.$timeout( () => {

            if(!!entity.id && !!this.$scope.adunit) {
                
                this.$scope.selectedEntity = entity;
                if(type == "layer") {
                    this.$scope.entityAsset = this.$scope.adunit.assets[entity.assetId];
                }

                this.$scope.$selectedEl = $("ad-" + type + "-designer#" + type + "-" + entity.id);
                if(this.$scope.$selectedEl.length) {
                    this.$el.css("display", "block");
                    this.visible = true;
                }

            }

        }, 0);
    }

    handleDoubleClick() {

        if(this.$scope.$selectedEl && (typeof "undefined" === this.$scope.selectedEntity.locked || !this.$scope.selectedEntity.locked)) {

            switch(this.$scope.entityAsset.contentType) {
                case "text/plain":
                    this.editText();
                    break;
                case "text/html":
                    this.editHtml();
                    break;
            }
        }
    }

    htmlEncode(value) {
        return $('<div/>').text(value).html();
    }

    htmlDecode(value) {
        return $('<div/>').html(value).text();
    }

    editText() {

        this.isEditing = true;
        this.disableInteraction();

        let asset = this.$scope.selectedEntity;
        let assetSrc = asset.src.replace(new RegExp('<br>','g'), '\r\n')
        let $editor = $("<pre contenteditable='true'>" + this.htmlEncode(assetSrc) + "</pre>");

        $editor.attr("style", this.$scope.$selectedEl.attr("style"));
        $editor.css("white-space", "pre-wrap");
        $editor.css("padding", "0");
        $editor.css({top: 0, left: 0, cursor: "text", "background-color": "white", "color": "black", "opacity" : 1});
        this.$el.append($editor);
        $editor.focus();

        $editor.on("blur", (ev) => {
            this.endEditText(asset, $editor, false);
        });

        $editor.on("keydown", (ev) => {
            if(ev.keyCode == 27) {//ESC
                this.endEditText(asset, $editor, true);
            }
            else if(ev.keyCode == 13) { // ENTER
                if(!ev.shiftKey) {
                    this.endEditText(asset, $editor, false);
                }
            }
        });

    }

    endEditText(asset, $editor, cancel) {

        if(!cancel) {
            asset.src = $editor.text().replace(new RegExp('\r?\n','g'), '<br>');
            this.$scope.$apply();
        }

        $editor.remove();

        this.isEditing = false;
        this.enableInteraction();
    }

    editHtml() {

        var inst = this.$uibModal.open({
            templateUrl: 'edit-layer-html.html',
            controller: 'SelectorHtmlEditor',
            windowClass: 'html-snippet-index',
            backdropClass: 'html-snippet-backdrop-index',
            size: "lg",
            resolve: {
                html: () => this.$scope.selectedEntity.src
            }
        });

        inst.result.then((html) => {
            this.$scope.selectedEntity.src = html;
        }, () => {
            
        });

    }

    setupDragHandles($scope) {

        $.each(this.handles, (ix, h) => {

            $(h.selector, this.$el).draggable({
                helper: "clone",
                appendTo: "body",
                containment: "parent",
                axis: h.axis,
                start: (ev, ui) => {

                    if(this.$scope.selectedEntity.contentType === "x-reflow/canvas") {
                        this.$scope.selectedEntity.size = "CUSTOM";
                    }

                    this.startDimsEl = {
                        top: this.$scope.$selectedEl.position().top,
                        left: this.$scope.$selectedEl.position().left,
                        width: this.$scope.$selectedEl.width(),
                        height: this.$scope.$selectedEl.height()
                    };
                    this.startDimsThis = {
                        top: this.$el.position().top,
                        left: this.$el.position().left,
                        width: this.$el.width(),
                        height: this.$el.height()
                    };
                    this.$rootScope.$emit("dragging-layer", true);
                },
                drag: (ev, ui) => {
                    //Only deal with drag events if the entity is not locked, would probably be worth disabling the handles completely?
                    if(!$scope.selectedEntity.locked) {
                        var el = $(ev.target);
                        var dir = el.attr("data-dir");
                        var delta = {
                            left: ui.offset.left - ui.originalPosition.left,
                            top: ui.offset.top - ui.originalPosition.top
                        };
                        if(delta.top > -this.startDimsThis.height || delta.left > -this.startDimsThis.width) {                        
                            this.handlers[dir].call(this, delta);
                        }
                        $scope.$apply();
                    }
                },
                stop: (ev, ui) => {
                    this.$rootScope.$emit("dragging-layer", false);
                }

            });

        });

    }

    handleN(delta, dims) {
        this.updateProps({
            top: this.startDimsEl.top + delta.top,
            height: this.startDimsEl.height - delta.top
        });
    }

    handleNE(delta, dims) {
        this.updateProps({
            top: this.startDimsEl.top + delta.top,
            height: this.startDimsEl.height - delta.top,
            width: this.startDimsEl.width + delta.left
        });
    }

    handleE(delta, dims) {
        this.updateProps({
            width: this.startDimsEl.width + delta.left
        });
    }

    handleSE(delta, dims) {
        this.updateProps({
            width: this.startDimsEl.width + delta.left,
            height: this.startDimsEl.height + delta.top
        });
    }

    handleS(delta, dims) {
        this.updateProps({
            height: this.startDimsEl.height + delta.top
        });
    }

    handleSW(delta, dims) {
        this.updateProps({
            left: this.startDimsEl.left + delta.left,
            width: this.startDimsEl.width - delta.left,
            height: this.startDimsEl.height + delta.top
        });
    }

    handleW(delta, dims) {
        this.updateProps({
            left: this.startDimsEl.left + delta.left,
            width: this.startDimsEl.width - delta.left,
        });
    }

    handleNW(delta, dims) {
        this.updateProps({
            top: this.startDimsEl.top + delta.top,
            left: this.startDimsEl.left + delta.left,
            width: this.startDimsEl.width - delta.left,
            height: this.startDimsEl.height - delta.top
        });
    }

    updateProps(props, doNotUpdateAsset) {

        
        var offset = this.$scope.$selectedEl.parent().offset();
        var builderOffset = $("ad-builder").offset();
        
        if("undefined" !== typeof offset) {

            let newProps = {
                width: props.width + 2,
                height: props.height + 2,
                top: props.top - 1,
                left: props.left - 1
            };

            if(this.$scope.selectedEntity.contentType === "x-reflow/layer") {
                let parentProps = this.$scope.$selectedEl.closest("ad-canvas-designer").position();
                newProps.top += parentProps.top;
                newProps.left += parentProps.left;
            }
            else if(this.$scope.selectedEntity.contentType === "x-reflow/canvas") {

                //Parse the height/width dimensions from creative type, alternative could use a map?
                if(this.$scope.selectedEntity.size !== "CUSTOM") {
                    let size = this.$scope.selectedEntity.size;
                    let search = size.search(/\d/);
                    let heightWidth = size.substring(search, size.length).split("x");
                    
                    if(heightWidth.length >= 2) {
                        props.width = newProps.width = heightWidth[0];
                        props.height = newProps.height = heightWidth[1];
                    }
                }
                else {
                    doNotUpdateAsset = false;
                }
            }

            this.$el.css(newProps);

        }
        
        if(!doNotUpdateAsset) {
            this.updateAsset(props);
        }

    }

    disableInteraction() {
        this.$el.droppable('option', 'disabled', true);
        this.$el.draggable('option', 'disabled', true);
        this.$el.parent().draggable('option', 'disabled', true);
        this.$el.parent().droppable('option', 'disabled', true);
    }

    enableInteraction() {
        this.$el.droppable('option', 'disabled', false);
        this.$el.draggable('option', 'disabled', false);
        this.$el.parent().draggable('option', 'disabled', false);
        this.$el.parent().droppable('option', 'disabled', false);
    }
    
    updateAsset(props) {
        
        this.$scope.$selectedEl.css(props);

        this.$scope.$evalAsync(() => {
            for (let prop in props) {
                if (props.hasOwnProperty(prop) && this.$scope.selectedEntity[prop] != props[prop]) {
                    this.$scope.selectedEntity[prop] = props[prop];
                }
            }
        });


    }

    handleKeyPress(ev) {
        let target = ev.target || ev.srcElement;
        let tagName = (target.nodeType == 1) ? target.nodeName.toUpperCase() : "";
        let isModalVisible = $("div[uib-modal-window='modal-window']").length > 0;
        let isBuilderVisible = $("ad-builder").is(':visible');
        if(this.visible && !this.isEditing && !/INPUT|SELECT|TEXTAREA/.test(tagName) && isBuilderVisible && !isModalVisible) {
            if(ev.keyCode === 46 || ev.keyCode == 8) { //Delete
                let type = this.$scope.selectedEntity.contentType.split("/")[1];
                this.$rootScope.$emit("delete-" + type, this.$scope.selectedEntity);
            }
            else if(ev.shiftKey) {
                switch(ev.keyCode) {
                    case 38: //key up
                        this.updateProps({ top: this.$scope.selectedEntity.top - 1 });
                        break;
                    case 40: // key down
                        this.updateProps({ top: this.$scope.selectedEntity.top + 1 });
                        break;
                    case 37: // key left
                        this.updateProps({ left: this.$scope.selectedEntity.left - 1 });
                        break;
                    case 39: // key right
                        this.updateProps({ left: this.$scope.selectedEntity.left + 1 });
                        break;
                }
            }
        }
    }

}

class AdSelector {

    constructor($timeout, $rootScope, $uibModal) {

        return {
            restrict: 'E',
            templateUrl: 'builder/selector.html',
            scope: {
                selectedTimeline: "=",
                selectedAnim: "=",
                adunit: "="
            },
            link: ($scope, $el, $attr) => {

                let delegate = new AdSelectorDelegate($scope, $el, $uibModal, $timeout, $rootScope);

            	$scope.$selectedEl = null;

                var lastDragTime = 0;
                $el.draggable({
                    appendTo: "workspace",
                    start: function() {
                        lastDragTime = new Date().getTime();
                        $rootScope.$broadcast("dragging-layer", true);

                    },
                    drag: (ev, ui) => {

                        var parentOffset = $scope.$selectedEl.parent().offset();
                        
                        let currentDragTime = new Date().getTime();
                        if(currentDragTime - lastDragTime < 500) {
                            $scope.$selectedEl.data("busy-dragging", true);
                        }
                        else {
                            $scope.$selectedEl.data("busy-dragging", false);
                            lastDragTime = currentDragTime;
                        }

                        delegate.updateProps({
                            top: ui.offset.top - parentOffset.top,
                            left: ui.offset.left - parentOffset.left
                        });
                        
                        $scope.$apply();

                    },
                    stop: (ev, ui) => {
                        let leftCanvasOffset = $('.builder-sidebar').width() + 48;
                        let canvasWidthOffset = leftCanvasOffset + $('ad-builder').width();
  
                        if(ui.offset.left < leftCanvasOffset - $scope.$selectedEl.width() || ui.offset.top < 58 - $scope.$selectedEl.height() || ui.offset.left > canvasWidthOffset ) {
                            // $rootScope.$on("delete-layer", (ev, args) => this.deleteLayer(this.$scope.$selectedEntity));
                            $rootScope.$broadcast('delete-layer', $scope.selectedEntity);
                            $scope.$apply();
                        }
                        $scope.$selectedEl.data("busy-dragging", false);
                        $rootScope.$broadcast("dragging-layer", false);
                    }
                });

                $el.droppable({
                    greedy: true,
                    tolerance: "pointer",
                    accept: (draggable) => {

                        var accept = false;

                        if(!!$scope.selectedEntity) {
                            
                            var widget = $(draggable).data("reflow-asset");
                            
                            if(!widget) {
                                return false;
                            }

                            if($scope.selectedEntity.contentType === 'x-reflow/canvas') {
                                accept = (widget.contentType === 'x-reflow/canvas');
                            }
                            else if($scope.selectedEntity.contentType === 'x-reflow/layer') {
                                let layerAsset = $scope.adunit.assets[$scope.selectedEntity.assetId];
                                if(!!layerAsset) {
                                    accept = (widget.contentType === 'x-reflow/canvas') ? !!layerAsset.acceptCanvas : true;
                                }
                            }
                        }
                        return accept;
                    },
                    over: (ev, ui) => {
                        $rootScope.pushDroppable($el);
                    },
                    out: (ev, ui) => {
                        $rootScope.popDroppable();
                    },
                    drop: (ev, ui) => {

                        if(ev.shiftKey || ($scope.selectedEntity.contentType === "x-reflow/layer" && $scope.entityAsset.contentType.startsWith("x-reflow-widget"))) {
                            if(ui.helper.is(".dropped")) {
                                return false;
                            }
                            ui.helper.addClass("dropped");
                            var widget = $(ui.draggable).data("reflow-asset");
                            delegate.handleDrop.call(delegate, widget);
                            $scope.$apply();
                        }
                    }
                });


                $el.dblclick(() => {
                	delegate.handleDoubleClick();
                });

                $(document).keydown((ev) => {
                    if(!delegate.isEditing) {
                        delegate.handleKeyPress(ev);
                        $scope.$apply();
                    }
                });

                delegate.setupDragHandles($scope);
                
                $rootScope.$on('select-builder', delegate.selectBuilder.bind(delegate));
                $rootScope.$on('select-canvas', delegate.selectCanvas.bind(delegate));
                $rootScope.$on('add-canvas', delegate.selectCanvas.bind(delegate));
            	$rootScope.$on('select-layer', delegate.selectLayer.bind(delegate));
                $rootScope.$on('add-layer', delegate.selectLayer.bind(delegate));
                

                $scope.$watch('selectedEntity', (newitem, olditem) => {

                    if(!!newitem && !!olditem && newitem.id !== olditem.id) {
                        olditem.selected = false;
                    }

                    if(!!newitem) {
                        
                        if(!!olditem && newitem.id !== olditem.id) {
                            newitem.selected = true;
                        }

                        if(typeof "undefined" === newitem.locked || newitem.locked === null | !newitem.locked) {
                            delegate.enableInteraction();
                        }
                        else {
                            delegate.disableInteraction();
                        }

                        delegate.updateProps({
                            width: newitem.width,
                            height: newitem.height,
                            top: newitem.top,
                            left: newitem.left
                        });
                    }

                }, true);

                $scope.$watch("selectedTimeline.state", (newitem) => {

                });

                $scope.$watch("selectedTimeline.time", (time) => {
                    
                    if(!$scope.selectedEntity) {
                        return;
                    }

                    $scope.$evalAsync(() => {
                        if($scope.selectedEntity.contentType === "x-reflow/layer" && !!$scope.selectedAnim && $scope.selectedAnim.layerId == $scope.selectedEntity.id) {
                            let props = {};
                            if(time == 0) {
                                props.width = $scope.selectedEntity.width;
                                props.height = $scope.selectedEntity.height;
                                props.top = $scope.selectedEntity.top;
                                props.left = $scope.selectedEntity.left;
                            }
                            else {
                                props.width = parseInt(!!("" + $scope.selectedAnim.props.width) || $scope.selectedEntity.width);
                                props.height = parseInt(!!("" + $scope.selectedAnim.props.height) || $scope.selectedEntity.height);
                                props.top = parseInt(!!("" + $scope.selectedAnim.props.top) || $scope.selectedEntity.top);
                                props.left= parseInt(!!("" + $scope.selectedAnim.props.left) || $scope.selectedEntity.left);
                            }
                            delegate.updateProps(props, true);
                        }
                    });
                });

            }

        };

    }
    
}

class SelectorHtmlEditor {

    constructor($scope, $uibModalInstance, html) {

        $scope.html = html;

        $scope.ok = () => {
            $uibModalInstance.close($scope.html);
        };

        $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };

    }

}

angular.module('cpm').controller("SelectorHtmlEditor", ["$scope", '$uibModalInstance', 'html', SelectorHtmlEditor]);

angular.module('cpm')
    .directive('adSelector', ['$timeout', "$rootScope", '$uibModal', ($timeout, $rootScope, $uibModal) => {
        'use strict';
        return new AdSelector($timeout, $rootScope, $uibModal);
    }]);
